export const radii = {
    x0: '0px',
    x_5: '2px',
    x1: '4px',
    x1_5: '6px',
    x2: '8px',
    x3: '12px',
    x3_5: '14px',
    x4: '16px',
};
//# sourceMappingURL=radius.js.map